<script setup>
import logo from "@/../images/logo.jpg";
import { useLoader } from '@/Stores/useLoader'

const loader = useLoader()
</script>

<template>
  <Teleport to="body">
    <div v-if="loader.isLoading" class="app-loader">
      <img :src="logo" alt="Loading..." class="logo-animation" loading="lazy" />
    </div>
  </Teleport>
</template>

<style scoped>
.app-loader {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  z-index: 9999;
}

/* Zoom in and out animation */
.logo-animation {
  width: 100px;
  height: 100px;
  animation: zoom 1s ease-in-out infinite;
}

@keyframes zoom {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2); /* how much it zooms */
  }
}
</style>
